import { render, staticRenderFns } from "./InstaVideo.vue?vue&type=template&id=89c328b6&"
import script from "./InstaVideo.vue?vue&type=script&lang=js&"
export * from "./InstaVideo.vue?vue&type=script&lang=js&"
import style0 from "./InstaVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports